export default {
  migration: 'migration',
  online: 'online',
};
